<template>
  <div class="index-page">
    <index-content></index-content>
  </div>
</template>

<script>
import utils from '../utils'
import userBehaviorLogs from '../api/userBehaviorLogs'
import getBrowserType from '../utils/getBrowserType'
import getPlatform from '../utils/getPlatform'
import indexContent from '../components/index/content'
export default {
  name: 'index',
  components: { indexContent },
  data () {
    return {
      browserType: getBrowserType(),
      platform: getPlatform()
    }
  },
  computed: {
    source () {
      return this.$route.params.source || utils.getQueryString('source') || '酒咔嚓'
    }
  },
  mounted () {
    userBehaviorLogs({
      op_event: '进入首页',
      source: this.source,
      query_column: document.referrer
    })
  }
}
</script>

<style scoped lang="less">
  @import "../less/variable";
</style>



// WEBPACK FOOTER //
// src/pages/index.vue